import { RenderPipeline } from 'three/webgpu'
import { pass } from 'three/tsl'
import MotionBlur from './MotionBlur'

export default class Composer {
	static defaults = { motionBlur: {} }

	constructor(renderer, scene, camera, options = {}) {
		this.options = { ...Composer.defaults, ...options }
		this.renderer = renderer
		this.#build(scene, camera)
	}

	#build(scene, camera) {
		this.pipeline = new RenderPipeline(this.renderer)
		this.scenePass = pass(scene, camera)
		this.motionBlur = new MotionBlur(this.scenePass, this.options.motionBlur)
		this.pipeline.outputNode = this.motionBlur.node
	}

	render() {
		this.pipeline.render()
	}

	dispose() {
		this.pipeline.dispose()
	}
}
